export default __webpack_public_path__ + "static/media/google_icon.9db27c10.png";